import { __assign, __rest } from "tslib";
import React, { useState, useEffect, useRef, useCallback } from 'react';
import classnames from 'classnames';
import { useBodyScrollLock } from '../../../utils/hooks/useBodyScollLock';
import UserMenuAvatar from './UserMenuAvatar';
import LoggedInUserMenu from './LoggedInUserMenu';
import LoggedOutUserMenu from './LoggedOutUserMenu';
import { useIosHeightHack } from './useIosHeightHack';
import s from './UserMenu.scss';
var UserMenu = function (_a) {
    var isOpen = _a.isOpen, onOpen = _a.onOpen, menuProps = __rest(_a, ["isOpen", "onOpen"]);
    var _b = useState(!!isOpen), isUserMenuOpened = _b[0], setIsUserMenuOpened = _b[1];
    var wasOpen = useRef(false);
    var _c = useBodyScrollLock(), onLock = _c.onLock, onUnlock = _c.onUnlock, setScrollableRef = _c.setScrollableRef;
    var _d = useIosHeightHack(), isIosHeightHackNeeded = _d.isIosHeightHackNeeded, setRootRef = _d.setRootRef;
    useEffect(function () {
        var isOpenChanged = wasOpen.current !== isOpen;
        if (isOpenChanged && isUserMenuOpened !== isOpen) {
            setIsUserMenuOpened(!!isOpen);
        }
        wasOpen.current = !!isOpen;
    }, [isOpen, isUserMenuOpened]);
    var openUserMenu = useCallback(function () {
        onLock();
        if (onOpen) {
            onOpen();
        }
        setIsUserMenuOpened(true);
    }, [onLock, onOpen]);
    var closeUserMenu = useCallback(function () {
        onUnlock();
        setIsUserMenuOpened(false);
    }, [onUnlock]);
    var toggleUserMenu = useCallback(function () { return (isUserMenuOpened ? closeUserMenu() : openUserMenu()); }, [closeUserMenu, isUserMenuOpened, openUserMenu]);
    return (React.createElement("div", { className: s['user-menu-wrapper'] },
        !isUserMenuOpened && (React.createElement(UserMenuAvatar, { currentUser: menuProps.currentUser, onToggleUserMenu: toggleUserMenu, isUserMenuOpened: false })),
        React.createElement("div", { className: classnames(s['user-menu-shade'], isUserMenuOpened && s['is-active']), 
            // Since react-onclickoutside wasn't really working for this component and my most
            // valiant efforts to make it do so were met with failure, just do it ourselves
            onTouchStart: toggleUserMenu, onClick: toggleUserMenu, "aria-hidden": !isUserMenuOpened }),
        React.createElement("div", { className: classnames(s['user-menu-list-wrapper'], isUserMenuOpened && s['is-opened'], isIosHeightHackNeeded && s['ios-sucks']), ref: function (node) {
                setScrollableRef(node);
                setRootRef(node);
            }, "aria-hidden": !isUserMenuOpened }, menuProps.isLoggedIn && menuProps.currentUser ? (React.createElement(LoggedInUserMenu, __assign({}, menuProps, { currentUser: menuProps.currentUser, isUserMenuOpened: isUserMenuOpened, onToggleUserMenu: toggleUserMenu }))) : (React.createElement(LoggedOutUserMenu, __assign({}, menuProps, { isUserMenuOpened: isUserMenuOpened, onToggleUserMenu: toggleUserMenu }))))));
};
UserMenu.displayName = 'UserMenu';
export default UserMenu;
//# sourceMappingURL=UserMenu.js.map